import { Module, ActionContext } from 'vuex';
import { RootStoreState } from '@/store';
import { SelectedUserGroupObjectType, SelectedUserObjectType, PartyGroupPermissionSection, ScopeUserGroupResponseContent, MsspPrefilterList } from './components/userGroupTypes';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface AccessManagementStoreState {
  selectedUserGroupObject: SelectedUserGroupObjectType;
  selectedUserObject: SelectedUserObjectType;
  PartyGroupPermissionSections: PartyGroupPermissionSection[];
  userGroups: any[];
  selectedMssp: SelectOption;
  setSelectedUserGroupName: string;
  userGroupScopeInfo: ScopeUserGroupResponseContent;
  selectedMsspObject: MsspPrefilterList;
  isRestrictedMSSPAccess: string;
  adminList: any[];
  triggerUserGroupApi: boolean;
  maxSuperAdminCount: number;
}
export default {
  state: {
    selectedUserGroupObject: {
      partyGroupId: '',
      partyGroupName: '',
      adminPartyId: '',
      status: '',
      isDefaultGroup: '',
      totalContacts: '',
      productGroupName: '',
      associatedPGList: [],
      setAsDefaultGroup: '',
      renameLink: '',
      usersForUserGroup: [],
      deleteLink: '',
      mgeProdGrpPagelink: '',
      isReadOnlyAccess: '',
      MSSPID: '',
      isAllMSSPTenants: '',
      msspScope: '',
      scopedMSSPID: '',
    },
    selectedUserObject: {
      name: '',
      login: '',
      email: '',
      partyGroupId: '',
      contactId:'',
      partyId: '',
      adminPartyId: '',
      lastAccessDate: '',
      dtLastAccessDate: '',
      lastAccessTime: '',
      isReadOnlyAccess: '',
    },
    PartyGroupPermissionSections: [],
    userGroups: [],
    isRestrictedMSSPAccess: '',
    selectedMssp: {
      id: '',
      value: '',
      label: '',
    },
    setSelectedUserGroupName: '',
    userGroupScopeInfo: {
      availbleProductGroup: [],
      assignedProductGroup: [],
    },
    selectedMsspObject: {
      MSSPName: '',
      MSSPID: 0,
      Tenants: [],
      isGlobal: '',
    },
    adminList: [],
    triggerUserGroupApi: false,
    maxSuperAdminCount: 0,
  },
  mutations: {
    setSelectedUserGroupObject(state, payload) {
      state.selectedUserGroupObject = payload.selectedUserGroupObject;
    },
    setSelectedUserObject(state, payload) {
      state.selectedUserObject = payload.selectedUserObject;
    },
    setPermissions(state, payload) {
      state.PartyGroupPermissionSections = payload.PartyGroupPermissionSections;
    },
    setUserGroups(state, payload) {
      state.userGroups = payload.userGroups;
    },
    setSelectedMssp(state, payload) {
      state.selectedMssp = payload.selectedMssp;
    },
    setUserGroupNameFromUserListPage(state, payload) {
      state.setSelectedUserGroupName = payload.setSelectedUserGroupName;
    },
    setUserGroupScopeData(state, payload) {
      state.userGroupScopeInfo = payload.userGroupScopeInfo;
    },
    setUsersForUserGroups(state, payload) {
      state.selectedUserGroupObject.usersForUserGroup = payload.usersForUserGroup;
    },
    setSelectedMsspObject(state, payload) {
      state.selectedMsspObject = payload.selectedMsspObject;
    },
    setisRestrictedMSSPAccess(state, payload) {
      state.isRestrictedMSSPAccess = payload.isRestrictedMSSPAccess;
    },
    setAdminList(state, payload) {
      state.adminList = payload;
    },
    setTriggerUserGroupApi(state, payload) {
      state.triggerUserGroupApi = payload;
    },
    setMaxSuperAdminCount(state, payload) {
      state.maxSuperAdminCount = payload;
    },
  },
  actions: {
    updateTFA(context: ActionContext<AccessManagementStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'multiupdatetfa';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    updateIDP(context: ActionContext<AccessManagementStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'multiupdateidp';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getAdminList(context: ActionContext<AccessManagementStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-admin-list';
      return ApiServiceWrapper.get(endpoint);
    },
    manageSuperAdmins(context: ActionContext<AccessManagementStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/migrate-org-based-structure';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  getters: {
    getSelectedUserGroupObject(state): SelectedUserGroupObjectType {
      return state.selectedUserGroupObject;
    },
    getPermissions(state): PartyGroupPermissionSection[] {
      return state.PartyGroupPermissionSections;
    },
    getUserGroupArray(state): any[] {
      return state.userGroups;
    },
    getSelectedMssp(state): SelectOption {
      return state.selectedMssp;
    },
    getUserGroupNameFromUserListPag(state): string {
      return state.setSelectedUserGroupName;
    },
    getUserGroupScopeData(state): ScopeUserGroupResponseContent {
      return state.userGroupScopeInfo;
    },
    getSelectedMsspObject(state): MsspPrefilterList {
      return state.selectedMsspObject;
    },
    getisRestrictedMSSPAccess(state): string {
      return state.isRestrictedMSSPAccess;
    },
    getAdminList(state): any {
      return state.adminList;
    },
    getTriggerUserGroupApi(state): any {
      return state.triggerUserGroupApi;
    },
    getMaxSuperAdminCount(state): any {
      return state.maxSuperAdminCount;
    },
  },
  namespaced: true,
} as Module<AccessManagementStoreState, RootStoreState>;
